<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal">
      <h3>Preview {{ streamName }}</h3>
      <p>
        <video ref="video" type="application/x-mpegURL" crossOrigin="anonymous" width="100%" height="50" controls ></video>
      </p>
      <div class="modal-actions">
        <a :href="getStream()" class="button">Stream URL</a>
        <!--<button @click="demo">Play</button>-->
        <button @click="close">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js';

export default {
  updated() {
      var config = {
        debug: false,
        maxMaxBufferLength: 10,
      };
      let hls = new Hls(config);
      let video = this.$refs["video"];
      hls.loadSource(this.getStream());
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => { });
  },
  beforeUpdate() {

    //video.play();
  },
  props: {
    streamName: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    demo() {
      var config = {
        debug: true,
      };
      let hls = new Hls(config);
      let video = this.$refs["video"];
      hls.loadSource(this.getStream());
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => { });
    },
    copy() {
      this.$emit('copy');
    },
    close() {
      let video = this.$refs["video"];
      video.pause();
      this.$emit('close');
    },
    getStream: function() {
      return "/streams/"+this.streamName+".m3u8";
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  text-align: center;
}

.modal h3 {
  margin-top: 0;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.modal-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

a.button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    color: buttontext;
    background-color: buttonface;
}

.modal-actions button:first-child {
  background-color: #e74c3c;
  color: white;
}

.modal-actions button:first-child:hover {
  background-color: #c0392b;
}

.modal-actions button:last-child {
  background-color: #3498db;
  color: white;
}

.modal-actions button:last-child:hover {
  background-color: #2980b9;
}
</style>